/**
 * 教研活动api
 */
import { getFetch, postFetch } from '@/plugins/http'
const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`

export default {
  /**
   * 教研活动-课程组-列表
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getActivitySelectCourseGroup(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-course_group_list/teaching_activity`, params, config)
  },
  /**
   * 教研活动-发起人-列表
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getActivityWaitTeacher(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-promoter_list/teaching_activity`, params, config)
  },
  /**
   * 获取课程组职务列表
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getPostRoleList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-course_group_role_list/teaching_activity`, params, config)
  },
  /**
   * 教研活动-必须参与-成员-列表
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getJoinTeacherMemberList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-must_member_list/teaching_activity`, params, config)
  },
  /**
   * 教研活动-邀请参与-成员-列表
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getInviteTeacherMemberList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-invite_member_list/teaching_activity`, params, config)
  },
  /**
   * 教研活动-活动类型-列表
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getActivityTypeList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/33-activity_type_list/teaching_activity`, params, config)
  },
  /**
   * 教研活动-保存
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  saveTeachingActivity(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-save/teaching_activity`, params, config)
  },
  /**
   * 教研活动-列表
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getTeachingActivityList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-list/teaching_activity`, params, config)
  },
  /**
   * 教研活动-发布
   * @param {*} params 
   * @param {*} config
   * @returns
   */
  publishTeachingActivity(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-publish/teaching_activity`, params, config)
  },
  /**
   * 教研活动-主讲人-添加
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  addActivitySpeaker(params = {}, config) {
    return postFetch(`${baseHost}/common/api/10-speaker_add/teaching_activity`, params, config)
  },
  /**
   * 教研活动-删除
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  deleteTeachingActivity(params = {}, config) {
    return postFetch(`${baseHost}/common/api/90-del/teaching_activity`, params, config)
  },
  /**
   * 教研活动-编辑回显信息
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getEditTeachingActivity(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-info/teaching_activity`, params, config)
  },
  /**
   * 教研活动-权限
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getTeachingActivityUserAuth(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-auth/teaching_activity`, params, config)
  },
  /**
   * 教研活动-参与状态-修改
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  updateTeachingActivityJoinStatus(params = {}, config) {
    return postFetch(`${baseHost}/common/api/20-join_status_upd/teaching_activity`, params, config)
  },
  /**
   * 教研活动-详情
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getTeachingActivityDetail(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-details/teaching_activity`, params, config)
  },
  /**
   * 教研活动-统计-信息
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getTeachingActivityStatisticInfo(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-statistics_info/teaching_activity`, params, config)
  },
  /**
   * 教研活动-统计-列表
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getTeachingActivityStatisticList(params = {}, config) {
    return getFetch(`${baseHost}/common/api/34-statistics_list/teaching_activity`, params, config)
  },
  /**
   * 教研活动-腾讯会议
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getTeachingActivityTecentMeeting(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-txhy_get/teaching_activity`, params, config)
  },
  /**
   * 教研活动-课程组职务-人数
   * @param {*} params 
   * @param {*} config 
   * @returns 
   */
  getTeachingActivityRoleNum(params = {}, config) {
    return getFetch(`${baseHost}/common/api/32-role_user_num_get/teaching_activity`, params, config)
  },
}
